export const WAEC_AGRIC_SCIENCE_LEARN_SS1 = [];